import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from 'Components/Base';

import ButtonScrollDown from './ButtonScrollDown';

const ScrollSeeMoreWrapper = ({ children, isShowScrollDown = false, ...restProps }) => (
  <Flex flexDirection="column" width={1} style={{ position: 'relative' }} {...restProps}>
    {children}
    {isShowScrollDown && <ButtonScrollDown />}
  </Flex>
);

ScrollSeeMoreWrapper.propTypes = {
  children: PropTypes.node,
  isShowScrollDown: PropTypes.bool,
};

export default ScrollSeeMoreWrapper;
